import { useAtomValue } from 'jotai';
import { whiteLabelThemeConfigState } from '../store/whitelabel-theme-settings';
import { MAIN_BRAND_NAME } from '../constants/user-team-ids';

export const useWhiteLabelConfig = () => {
  const whiteLabelConfig = useAtomValue(whiteLabelThemeConfigState);
  const isNonWhiteLabel = whiteLabelConfig?.name?.toLowerCase() === MAIN_BRAND_NAME.toLowerCase();
  return { whiteLabelConfig, isNonWhiteLabel, isWhiteLabeledCompany: !isNonWhiteLabel };
};
